import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) =>
  createStyles({
    linearProgress: ({ isCreateUrl }: {isCreateUrl: boolean}) => ({
      position: 'absolute',
      left: isCreateUrl ? 0 : 10,
      right: isCreateUrl ? 0 : 10,
      bottom: isCreateUrl ? 0 : 10,
      borderBottomLeftRadius: isCreateUrl ? 0 : theme.shape.borderRadius,
      borderBottomRightRadius: isCreateUrl ? 0 : theme.shape.borderRadius,
    }),
  }),
);
